<template>
  <v-container id="data-tables" tag="section" fluid>
    <base-material-card color="primary" icon="mdi-clipboard-outline" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Conciliações</div>
      </template>

      <v-btn
        id="btn-nova-conciliacao"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push(`edit`)"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        NOVA CONCILIAÇÃO
      </v-btn>

      <v-text-field
        id="conciliacoes-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-concilicoes ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />

      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Conciliação" />

      <v-divider class="mt-10" />

      <v-data-table
        class="conciliacoes-table"
        :headers="headers"
        :items="conciliacoes"
        :search.sync="search"
        no-data-text="Nenhuma conciliação disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :header-props="{ sortByText: 'Ordenar Por' }"
        :footer-props="{ itemsPerPageText: 'Itens por Página' }"
        mobile-breakpoint="800"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="text-truncate-column"
                :class="['EXECUTANDO', 'AGUARDANDO'].includes(item.status) ? 'clickable-item' : ''"
                v-bind="attrs"
                @click="openDialogAcompanhamento(item)"
                v-on="on"
              >
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario }}
        </template>
        <template v-slot:[`item.executed`]="{ item }">
          {{ item.executed }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-conciliacao"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn
            id="action-edit-conciliacao"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.tipoConciliacao.toLowerCase() === 'avançada' ? 'custom' : 'express'}/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-conciliacao"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarItem(item.id)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-play</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Executar</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.status == 'SUCESSO'" @click="duplicarItem(item.id)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Duplicar</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Deletar</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-file-find-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Detalhes</v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadLogs(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-file-download-outline</v-icon>
                  Downlad Logs
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
      </v-data-table>
    </base-material-card>

    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Conciliação #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar a conciliação
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>
    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes da Conciliação"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="[
            { text: 'Parâmetro', value: 'parametro', sortable: false },
            { text: 'Valor', value: 'valor', sortable: false }
          ]"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">
                {{ row.item.parametro }}
              </td>
              <td
                v-if="'arquivo_id' in row.item"
                class="download-arquivo-detalhes-click"
                @click="downloadArquivoById(row.item.arquivo_id, row.item.arquivo_nome)"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-progress-circular v-if="loadingDownloadArquivoById" indeterminate color="primary" size="20" />
                      <span v-else>{{ row.item.arquivo_nome }}</span>
                    </div>
                  </template>
                  <span v-if="loadingDownloadArquivoById">AGUARDE :: Baixando arquivo [{{ row.item.arquivo_nome }}]...</span>
                  <span v-else>Clique aqui para baixar o arquivo</span>
                </v-tooltip>
              </td>
              <td v-else class="button">
                {{ row.item.valor }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
    <general-dialog-acompanhamento
      ref="dialogAcompanhamento"
      :show-dialog="dialogAcompanhamento"
      :messages="dialogAcompanhamentoData.andamento"
      :name-event-pusher="'andamento-conciliacao-' + dialogAcompanhamentoData.id"
      @changeValue="dialogAcompanhamento = $event"
    >
      <template slot="title">Andamento da Conciliação #{{ dialogAcompanhamentoData.id }}</template>
    </general-dialog-acompanhamento>
  </v-container>
</template>

<script>
  import ConciliacoesService from '@/services/ConciliacoesService.js';
  import powerupsActionsMixis from '@/mixins/powerupsActionsMixins.js';

  export default {
    name: 'ConciliacoesDataTable',

    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes'),
      GeneralDialogAcompanhamento: () => import('@/components/general/GeneralDialogAcompanhamento')
    },

    mixins: [powerupsActionsMixis],

    props: {
      conciliacoes: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    emits: ['switchProcessamentosExpirados'],

    data: () => ({
      powerupService: ConciliacoesService,
      powerupEntityName: 'Conciliação',
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Usuário',
          value: 'usuario'
        },
        {
          text: 'Executado',
          value: 'executed'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ]
    }),

    methods: {
      downloadLogs(id) {
        const empresa = this.$store.getters.getEmpresa;
        ConciliacoesService.downloadLogs({ id, empresa })
          .then((res) => {
            this.$toast.success('Preparando seu arquivo de logs para download.', '', { position: 'topRight' });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `logs-conciliacoes-${id}.log`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Falha ao baixar arquivo resultado :: Arquivo não encontrado.', '', { position: 'topRight' });
          });
      },
      openDialogDetalhes(conciliacao) {
        this.dialogDetalhesData = [
          {
            parametro: 'NOME:',
            valor: conciliacao.nome
          },
          {
            parametro: 'TIPO DE CONCILIAÇÃO:',
            valor: conciliacao.tipoConciliacao === 'Express' ? 'Express' : 'Custom'
          },
          {
            parametro: 'FLEXIBILIDADE:',
            valor: conciliacao.flexibilidade
          },
          {
            parametro: 'PRIORIDADES:',
            valor: conciliacao.prioridades
          },
          {
            parametro: 'RODADAS:',
            valor: conciliacao.numeroRodadas
          },
          {
            parametro: 'HABILITAR ATRIBUTOS CORINGA?:',
            valor: conciliacao.atributosCoringa ? 'Sim' : 'Não'
          },
          {
            parametro: 'TOTAL CONCILIADO:',
            valor: conciliacao.status === 'AGUARDANDO' ? '-' : this.parseNumberToDecimalBR(conciliacao.totalConciliado)
          },
          {
            parametro: 'SOBRAS PARTIDA:',
            valor: conciliacao.status === 'AGUARDANDO' ? '-' : this.parseNumberToDecimalBR(conciliacao.sobrasPartida)
          },
          {
            parametro: 'SOBRAS REFERÊNCIA:',
            valor: conciliacao.status === 'AGUARDANDO' ? '-' : this.parseNumberToDecimalBR(conciliacao.sobrasReferencia)
          }
        ];

        if (conciliacao.arquivoPartida) {
          this.dialogDetalhesData.push({
            parametro: 'ARQUIVO BASE DE PARTIDA:',
            arquivo_nome: conciliacao.arquivoPartida,
            arquivo_id: conciliacao.arquivoPartidaId
          });
        } else {
          this.dialogDetalhesData.push({
            parametro: 'CONSULTA BASE DE PARTIDA:',
            valor: conciliacao.consultaPartida
          });
        }

        if (conciliacao.arquivoReferencia) {
          this.dialogDetalhesData.push({
            parametro: 'ARQUIVO BASE DE REFERÊNCIA:',
            arquivo_nome: conciliacao.arquivoReferencia,
            arquivo_id: conciliacao.arquivoReferenciaId
          });
        } else {
          this.dialogDetalhesData.push({
            parametro: 'CONSULTA BASE DE REFERÊNCIA:',
            valor: conciliacao.consultaReferencia
          });
        }

        if (conciliacao.tipoConciliacao === 'Express') {
          this.dialogDetalhesData.splice(3, 0, {
            parametro: 'TUC SELECIONADA:',
            valor: conciliacao.tucSelecionada
          });
        }

        this.dialogDetalhes = true;
      },

      parseNumberToDecimalBR(num, minimumFractionDigits = 2, maximumFractionDigits = 2) {
        return Number(num).toLocaleString('pt-BR', {
          minimumFractionDigits: minimumFractionDigits,
          maximumFractionDigits: maximumFractionDigits
        });
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .conciliacoes-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .conciliacoes-table table tr td:nth-child(6),
    .conciliacoes-table table tr td:nth-child(7) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-concilicoes {
      width: 209.91px !important;
    }
  }

  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>
